export default {

    methods: {
        sendDataForSaving(form) {
            this.$emit('data-changed', form);
        },
    }
}
